import {toKebabCase} from "@infonova/framework/lib/util/string/toKebabCase";
import {GenerateId} from "jss";

let counter = 0;

export const generateClassName: GenerateId = (rule, sheet) => {
    const key = toKebabCase(rule.key);
    if (rule.isProcessed) {
        return `intr-${key}-${counter++}`;
    } else {
        return `intr-${key}`;
    }
};
